class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    this.els = {
      submit: this.querySelectorAll('[data-product-quick-add-el="submit"]'),
      selectedVariant: this.querySelector('[data-product-quick-add-el="variant"]')
    };
  }

  setupEventListeners() {
    this.els.submit.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const variantId = event.currentTarget.getAttribute('data-value');

        this.els.selectedVariant.value = variantId;

        window.Moonbase.ajaxCart.handleAddToCartClick(event);
      });
    });
  }
}

customElements.define('product-quick-add', ProductQuickAdd);
